import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import logo from '../../assets/icons/halterix-coral.png';

const useStyles = makeStyles((theme) => ({
  footer: {
    backgroundColor: 'white',
    position: 'fixed',
    bottom: '0',
    height: '200px',
    width: '100%',
    zIndex: 1,
    flexGrow: 1,
    color: theme.palette.text.secondary,
    '& p': {
      fontSize: '13px',
    },
  },
  container: {
    height: '100%',
  },
  section: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
  },
  info: {
    alignItems: 'center',
    justifyContent: 'space-evenly',
  },
  address: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  contact: {
    width: '70%',
    display: 'flex',
    justifyContent: 'space-evenly',
  },
  links: {
    alignItems: 'flex-end',
    paddingTop: '30px',
    height: '100%',
    justifyContent: 'space-around',
    paddingRight: '15%',
  },
}));

export const Footer: React.FC = () => {
  const classes = useStyles();
  return (
    <Paper className={classes.footer} elevation={3}>
      <Grid container className={classes.container}>
        <Grid item xs={4}></Grid>
        <Grid item xs={4}>
          <div className={`${classes.section} ${classes.info}`}>
            <img src={logo} alt="logo" />
            <div className={classes.address}>
              <Typography>4 Victoria Street, Toronto, ON M5E 1L4</Typography>
              <Typography>Canada</Typography>
            </div>
            <div className={classes.contact}>
              <Typography>info@halterix.com</Typography>
              <Typography>|</Typography>
              <Typography>+1 647-812-6486</Typography>
            </div>
          </div>
        </Grid>
        <Grid item xs={4}>
          <div className={`${classes.section} ${classes.links}`}>
            <Typography>
              <Link
                href="https://halterix.com/halterix-pt-beta-clinic-faq/"
                color="textSecondary">
                FAQ
              </Link>
            </Typography>
            <Typography color="textSecondary">
              <Link
                href="https://halterix.com/halterix-pt-beta-terms-and-conditions-patients/"
                color="textSecondary">
                User Agreement
              </Link>
            </Typography>
            <Typography color="textSecondary">
              <Link
                href="https://halterix.com/privacy-policy/"
                color="textSecondary">
                Privacy Policy
              </Link>
            </Typography>
          </div>
        </Grid>
      </Grid>
    </Paper>
  );
};
